import React from 'react';
import { buildGalleryContent } from './utils';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('MediaGallery');

interface Image {
    id: string;
    url: string;
    alt: string;
    srcSet?: string;
}

interface Thumbnail {
    alt: string;
    url: string;
}

interface Video {
    url: string;
    thumbnail?: Thumbnail;
}

interface MediaGalleryProps {
    images: Image[];
    videos: Video[];
    isVideoFirst: boolean;
    isLargeDesktop: boolean;
    /* eslint-disable no-unused-vars */
    setIsZoomModalVisible: (visible: boolean) => void;
    setSelectedZoomImageIndex: (index: number) => void;
    /* eslint-enable no-unused-vars */
}

const MediaGallery = (props: MediaGalleryProps) => {
    const mediaGalleryContent = buildGalleryContent({ ...props, bem });

    return (
        <>
            {mediaGalleryContent.map(({ component }) => {
                return component;
            })}
        </>
    );
};

export default MediaGallery;
